import styled from 'styled-components';

export const QueueList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
  max-height: 400px;
  overflow-y: auto;
`;

export const QueueItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.palette.background.default};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const QueueItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const QueueItemTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const QueueItemTime = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StatusBadge = styled.div<{ $status: 'pending' | 'syncing' | 'failed' | 'submitted' }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;

  ${({ $status, theme }) => {
    switch ($status) {
      case 'syncing':
        return `
          background-color: ${theme.palette.info.light}20;
          color: ${theme.palette.info.main};
        `;
      case 'failed':
        return `
          background-color: ${theme.palette.error.light}20;
          color: ${theme.palette.error.main};
        `;
      case 'submitted':
        return `
          background-color: ${theme.palette.success.light}20;
          color: ${theme.palette.success.main};
        `;
      case 'pending':
      default:
        return `
          background-color: ${theme.palette.warning.light}20;
          color: ${theme.palette.warning.dark};
        `;
    }
  }}
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;

export const EmptyStateIcon = styled.div`
  margin-bottom: 12px;
  opacity: 0.5;
`;

export const EmptyStateText = styled.p`
  margin: 0;
  font-size: 14px;
`;

export const QueueSummary = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  margin-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const SummaryText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
